export default __webpack_public_path__ + "static/media/sd-event-3.976b3f2d.png";